// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-cities[data-v-417df7e4]{color:#696984;margin:20px}div[data-v-417df7e4]{font-size:1.2rem;margin-bottom:20px;margin-top:20px}@media (min-width:768px){.container-cities[data-v-417df7e4]{margin-left:60px;margin-right:60px}}@media (min-width:1024px){.container-cities[data-v-417df7e4]{margin-left:100px;margin-right:100px}}@media (min-width:1440px){.container-cities[data-v-417df7e4]{margin-left:228px;margin-right:228px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
